import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordsCompareAsTheSame(password: string, comparePassword: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const passwordIsValid = control.value[password] === control.value[comparePassword];
    return passwordIsValid ? null : { passwordMatch: true };
  };
}

export function passwordValidator(control: AbstractControl): { invalidPassword: boolean } {
  const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()=+|`~._-])[A-Za-z\d@$!%*?&#^()=+|`~._-]{6,}$/;
  return control.value.match(pattern) ? null : { 'invalidPassword': true };
}
